<template>
  <div
    @mouseenter="focusCart"
    :style="{ top: $route.name == 'store' ? '80px' : '20px', position:'sticky' }"
  >
    <div class="bg-white">
      <div>
        <div v-if="cartItems.length > 0" class="container-fluid p-0">
          <div class="row shopping-cart-clearall">
            <div class="col-md-6">
              <h3 class="text-gray">{{ $t('message.order') }}</h3>
            </div>
            <div class="btn col-md-6 text-right">
              <a
                @click="clearAllOrders()"
                :style="desktopStyles.LinkColorTxt"
              >{{ $t('message.clearAll') }}</a>
            </div>
          </div>
          <hr class="m-0" />
        </div>
        <div class="container">
          <div class="row cart-items wholeOrderDiscount" v-if="wholeOrderDiscount">
            <div
              :style="desktopStyles.successMsg"
              class="discount-container"
            >{{wholeOrderDiscountMessage}}</div>
          </div>
        </div>
        <div ref="cartWrapper" v-if="cartItems.length > 0" class="cart-items-wrapper">
          <div class="container">
            <template v-for="(item, index) in cartItems">
              <cart-item :cart-item="item" :key="index" :index="index" />
            </template>
          </div>

          <hr v-if="cartItems.length > 0" />
          <div class="container price-container" v-show="cartItems.length > 0">
            <div class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">
                  {{ $t('message.subtotal') }}
                  <small class="fw-600">({{ cartLength }} items)</small>
                </div>
                <div class="cart-subtotal-cost">{{ subtotalPrice | formatMoney }}</div>
              </div>
            </div>
            <div v-if="showDelivery" class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">{{ $t('message.delivery') }}</div>
                <div class="cart-subtotal-cost">{{ deliveryFee | formatMoney }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">{{ $t('message.gst') }}</div>
                <div class="cart-subtotal-cost">{{ totaltax | formatMoney }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">{{ $t('message.discount') }}</div>
                <div class="cart-subtotal-cost">{{ discount | formatMoney }}</div>
              </div>
            </div>
            <div class="row" v-show="orderMode">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">{{ $t('message.surcharge') }}</div>
                <div class="cart-subtotal-cost">{{ getSurchargeAmount | formatMoney }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr v-show="cartItems.length > 0 && cartValue > 0 && $route.name == 'checkout'" />
      <div v-if="canshowRedemption" class="container">
        <div class="row pt-4">
          <div @click="addReedemption()" class="col-sm-12 checkout">
            <a
              class="btn redeem-btn btn-lg btn-block mb-2"
            >{{ $t('message.redeemStamps') }}: {{ canshowRedemption.Name }}</a>
          </div>
        </div>
      </div>
      <div
        class="container"
        v-show="cartItems.length > 0 && cartValue > 0 && $route.name == 'checkout'"
      >
        <div class="row">
          <CouponComponent ref="couponComponent" :className="'cart-totals'"></CouponComponent>
        </div>
      </div>
      <hr v-show="cartItems.length > 0 && cartValue > 0 && $route.name == 'checkout'" />
      <div class="container">
        <div class="row">
          <div class="col-sm-12 cart-totals">
            <div class="total">{{ $t('message.totalIncGST') }}</div>
            <div v-if="getPoints" class="cost has-point">
              <span class="px-2">{{ totalPrice | formatMoney }}</span>
              <span class="points text-success">({{ getPoints| formatNumber }} pts)</span>
            </div>
            <div v-else class="cost">{{ totalPrice | formatMoney }}</div>
          </div>
        </div>
      </div>
      <div class="container" v-if="orderMode && currentStoreDoc.TermsAndConditions">
        <div class="d-flex privacy-policy">
          <div class="privacy-policy-checkbox">
            <Checkbox v-model="privacyPolicyCheckbox" :label="''"></Checkbox>
          </div>
          <div class="privacy-policy-link">
            I agree to
            <a
              :style="desktopStyles.LinkColorTxt"
              @click="openPrivacyPolicyModal()"
            >the terms and conditions</a>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 checkout">
            <button
              v-if="orderMode"
              :disabled="orderDisbaled"
              type="submit"
              class="btn btn-primary btn-lg btn-block shadow mb-2 d-flex justify-content-center align-items-center"
              :style="desktopStyles.btn"
            >
              {{ $t('message.placeOrder') }}
              <span v-show="proccessing">
                <i class="spin ml-4" />
              </span>
            </button>
            <router-link
              v-else
              :to="{ name: 'checkout', params: {storeid: $route.params.storeid, storename: $route.params.storename } }"
              :class="{
                disabled:
                  cartItems.length === 0 || storeClosed === true
                    ? 'disabled'
                    : ''
              }"
              class="btn btn-primary btn-lg btn-block shadow mb-2"
              :style="desktopStyles.btn"
            >{{ storeClosed ? "Store closed" : "Checkout" }}</router-link>
            <div v-show="storeClosed" class="pt-1" v-html="store.ClosingStoreMessage" />
            <div
              v-show="!exceedMinPurchase && orderMode && !storeClosed"
              class="color-red pt-1 text-center fs-90"
            >{{ $t('message.minimumPurchaseIs') }} {{ minPurchase | formatMoney }}</div>
            <div
              v-show="IsInOperationMessage && !store.IsInOperation"
              class="p-2 color-red text-center fs-90"
            >{{IsInOperationMessage}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="orderMode" class="m-4">
      <button
        type="button"
        class="btn btn-block p-2 continue-order-btn"
        @click="continueOrder"
      >{{ $t('message.continueOrdering') }}</button>
    </div>
    <poweredby v-if="!isBranded()" />

    <modal ref="redemptionModal" v-if="showRedemption" full-header @close="closeModal" hide-footer>
      <template slot="body">
        <div style="height: calc(100vh - 100px); overflow-y: auto; margin-bottom: 50px;">
          <Modifiers
            @canceled="closeModal"
            :product="selectedReedemption.product"
            :modifiers="selectedReedemption.modifiers"
            :product-id="selectedReedemption.productId"
            @updated="selectRollIntoModiefiers"
            :is-submodifier="true"
            :has-confirm-button="true"
          />
        </div>
      </template>
    </modal>

    <modal
      ref="privacyModal"
      v-if="showPrivacyModal"
      full-header
      @close="closePrivacyPolicyModal"
      @open="changeSticky(true)"
    >
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">Terms And Conditions</h2>
          </div>
          <p class="py-4 terms-and-conditions" v-html="currentStoreDoc.TermsAndConditions"></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index:2">
          <button
            class="privacy-btn pull-right"
            data-dismiss="modal"
            type="button"
            @click="closePrivacyPolicyModal()"
          >{{ $t('message.ok') }}</button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
  </div>
</template>

<script>
import CartItem from "./CartItem";
import { getStore } from "../../../api/services/storeService.js";
import { IsStoreOpenAtTime } from "./../../../api/helpers/datetimeHelper.js";
import { DateTime } from "luxon";
import poweredby from "../../shared/poweredby";
import CouponComponent from "./CouponComponent";
//import uuid from "uuid/v1";
import modal from "../../modal";
import Modifiers from "../products/Modifiers";
import shared from "../../../sharedscripts/shop/shopping-cart/ShoppingCart.js";
import { $$ } from "../../../sharedscripts/OO_jquery.js";
import Checkbox from "../../shared/checkbox";
// import {
//   priceTriggerType,
//   OutcomePriceType
// } from "../../../api/constants/priceTriggerEnums";
export default {
  name: "ShoppingCart",
  components: {
    CartItem,
    poweredby,
    CouponComponent,
    modal,
    Modifiers,
    Checkbox
  },
  props: {
    orderMode: {
      type: Boolean,
      default: false
    },
    proccessing: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      IsInOperationMessage: null,
      store: {},
      storeClosed: false,
      timerId: null,
      minPurchase: 0,
      selectedReedemption: null,
      showRedemption: false,
      privacyPolicyCheckbox: false,
      showPrivacyModal: false,
      targetElement: {}
    };
  },
  computed: {
    ...shared.computed
  },
  watch: {
    store(newValue) {
      this.storeClosed = !IsStoreOpenAtTime(newValue, DateTime.local());
      this.computeRules(this.orderType);
    },
    orderType(newValue) {
      this.computeRules(newValue);
    },
    totalPrice() {
      this.computeRules(this.orderMode);
    },
    subtotalPrice(newValue) {
      this.initDeliveryInfo(newValue);
    },
    cartItems: {
      handler: function(newValue) {
        this.fixRedemptionQuantity(newValue);
      },
      deep: true
    }
  },

  created() {
    let that = this;
    getStore(this.$route.params.storeid).onSnapshot(
      function(doc) {
        if (doc.exists) {
          that.store = doc.data();
          that.IsInOperationMessage = "Store is not in operation.";
          if (that.store.ChargeToRoom) {
            that.destroyOldCard();
            that.timerId = setInterval(that.destroyOldCard, 5000);
          }
          that.initDeliveryInfo(0);
        }
      },
      function(reason) {
        that.insertErrorlog([
          reason.name,
          reason.toString(),
          that.$router.currentRoute.fullPath
        ]);
        that.redirectToErrorPage();
      }
    );
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  updated() {
    var elem = $$("#uniquemodal");
    if (elem.length > 0) {
      //elem.remove();
      var cart = $$("#shopping-cart");
      cart.append(elem);
    }
  },
  methods: {
    ...shared.methods,
    openPrivacyPolicyModal() {
      this.showPrivacyModal = true;
    },
    closePrivacyPolicyModal() {
      this.$refs.privacyModal.hideModal();
      this.showPrivacyModal = false;
    }
  }
};
</script>
